import { Drawer } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'
import { VatDeclarationsPeriod } from '@features/vatDeclarations/types/vatDeclarationsPeriod'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useTransactionStaticActions } from '../../../../hooks/useTransactionStaticActions'
import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { BookingsSection } from '../../elements/BookingsSection/BookingsSection'
import { DetailsSection } from '../../elements/DetailsSection'
import { HeroSection } from '../../elements/HeroSection'
import { Separator } from '../../elements/Separator'

interface VatReturnViewProps {
  vatReturn: VatDeclarationsPeriod
}

export const VatReturnView = ({ vatReturn }: VatReturnViewProps) => {
  const { t } = useTranslation()
  const { isVoidedEntry, transactionNo, transaction, transactionId, originatorCurrencyId } =
    useTransactionDrawerContext()
  const { organization } = useUserOrganization()

  const { id, periodText, totalAmount } = vatReturn
  const { handleSelect, items, modals } = useTransactionStaticActions({
    isVoided: isVoidedEntry,
    originatorId: id,
    originatorType: TransactionOriginatorType.SalesTaxReturn,
    transactionId,
  })

  const { entryDate, createdTime } = transaction || {}
  const baseCurrencyId = organization?.baseCurrencyId || 'EUR'

  return (
    <>
      <Drawer.Header
        actions={items}
        closable
        onAction={handleSelect}
        title={t('ledger.drawer_title', { number: transactionNo })}
      />
      <Drawer.Body withPadding={false} gap="0">
        <HeroSection
          amount={totalAmount}
          currency={originatorCurrencyId || baseCurrencyId}
          entryDate={entryDate}
          source={periodText}
        />
        <Separator />
        <BookingsSection originatorCurrency={originatorCurrencyId} />
        <Separator />
        <DetailsSection createdTime={createdTime} />
        <Separator />
      </Drawer.Body>
      {modals}
    </>
  )
}
